import { Link } from "react-router-dom";
import notFoundImg from "../../assets/error.png";
function PageNotFound() {
  return (
    <div className="pt-4">
      <section className="our-error bgc-f7 header-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1 text-center">
              <div className="error_page footer_apps_widget">
                <img className="img-fluid" src={notFoundImg} alt="404" />
                <div className="erro_code">
                  <h1>Ohh! Page Not Found</h1>
                </div>
                <p>We can’t seem to find the page you’re looking for</p>
              </div>
              <Link className="btn btn_error btn-thm" to="/">
                Back To Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PageNotFound;
